import { render, staticRenderFns } from "./familyMembersForm.vue?vue&type=template&id=689fe890&scoped=true"
import script from "./familyMembersForm.vue?vue&type=script&lang=js"
export * from "./familyMembersForm.vue?vue&type=script&lang=js"
import style0 from "./familyMembersForm.vue?vue&type=style&index=0&id=689fe890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689fe890",
  null
  
)

export default component.exports